"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _InformationChange = require("@/api/member/InformationChange");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  props: {
    memberId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      tableData: []
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    unBind: function unBind(val) {
      var _this = this;
      this.$confirm('是否确认解绑?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _InformationChange.unbindPlatformAuth)({
          memberId: _this.memberId,
          platform: val.unionCode
        }).then(function (res) {
          _this.$notify.success({
            title: '温馨提示',
            message: '操作成功'
          });
          _this.getList();
        });
      });
    },
    getList: function getList() {
      var _this2 = this;
      (0, _InformationChange.getunioninfo)({
        memberId: this.memberId
      }).then(function (res) {
        _this2.tableData = res.data;
      });
    }
  }
};